export class Suggestion {
    id: number;
    Sentence: { [key: string]: string };
    Description: string;
    IsNormality?: boolean;
    code: string;
    newLineAfter: boolean;
    groupNameHashCode?: number;
}

export interface ExtendedSuggestion {
    suggestion: Suggestion;
    policy: boolean;
}
